export enum Constants {
  // BrandName = 'SeeTheLane',
  BrandName = 'Superior Bowling',
  AppName = 'SeeTheLane',
}
